<template>
  <div>
    <footer class="modern-footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="footer-brand">
              <div class="logo-wrapper">
                <img src="/assets/images/logo.png" alt="DB Robot" class="footer-logo">
                <span class="logo-text">DB ROBOT</span>
              </div>
              <p class="brand-desc">
                대한민국 최대 데이터베이스 플랫폼<br>
                실시간 업데이트되는 기업 정보를 제공합니다
              </p>
            </div>
          </div>

          <div class="col-lg-2 col-md-6">
            <div class="footer-widget">
              <h5>서비스</h5>
              <ul class="footer-links">
                <li><router-link to="/database/openmarket">오픈마켓 DB</router-link></li>
                <li><router-link to="/database/corp">법인 DB</router-link></li>
                <li><router-link to="/database/office">기업 DB</router-link></li>
                <li><router-link to="/database/licensedb">인허가 DB</router-link></li>
                <li><router-link to="/category-search">업종별 검색</router-link></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-2 col-md-6">
            <div class="footer-widget">
              <h5>지원</h5>
              <ul class="footer-links">
                <li><router-link to="/notice">공지사항</router-link></li>
                <li><router-link to="/faq">FAQ</router-link></li>
                <li><a href="http://pf.kakao.com/_NhgJT" target="_blank">1:1 문의</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="footer-widget">
              <h5>연락처</h5>
              <div class="contact-info">
                <div class="contact-item">
                  <i class="fa fa-phone"></i>
                  <div>
                    <strong>대표전화</strong>
                    <p>0507-2097-1711</p>
                  </div>
                </div>
                <div class="contact-item">
                  <i class="fa fa-envelope"></i>
                  <div>
                    <strong>이메일</strong>
                    <p>da.98738@databot.co.kr</p>
                  </div>
                </div>
                <div class="contact-item">
                  <i class="fa fa-map-marker"></i>
                  <div>
                    <strong>주소</strong>
                    <p>경기도 성남시 수정구 위례서일로 34 성희프라자 413호</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="footer-disclaimer">
          <div class="disclaimer-item">
            <i class="fa fa-shield"></i>
            <p>본 서비스의 데이터베이스는 '데이터봇'이 공식 라이센스를 통해 합법적으로 수집한 자료입니다. 웹 사이트 상의 모든 콘텐츠에 대한 저작권은 '데이터봇'이 보유하고 있으며, 이에 대한 무단 사용 및 재배포를 금지합니다.</p>
          </div>
          <div class="disclaimer-item">
            <i class="fa fa-exclamation-triangle"></i>
            <p>수집된 정보가 변경되었거나 잘못되어 발생하는 문제에 대한 모든 책임은 정보이용자에게 있으며 정보 이용으로 인해 발생한 손해 및 민/형사상 책임에 대해서는 법적 책임을 지지 않습니다.</p>
          </div>
          <div class="disclaimer-item">
            <i class="fa fa-balance-scale"></i>
            <p>본 서비스를 영리 목적의 광고에 활용할 경우 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제50조의 준수사항을 반드시 이행해야 하며, 위반 시 관련 법령에 의거하여 처벌될 수 있습니다.</p>
          </div>
          <div class="disclaimer-item">
            <i class="fa fa-ban"></i>
            <p>데이터 관련 상품은 다음 규정에 의거하여 환불이 불가능합니다. "컨설팅 서비스 완료 후 또는 자료, 프로그램 등의 서비스 제공 이후에는 환불이 불가합니다.(소비자보호법 제17조 제2항 제5호. 용역 또는 「문화산업진흥 기본법」 제2조제5호의 디지털콘텐츠 제공 개시에 해당)"</p>
          </div>
          <div class="disclaimer-item">
            <i class="fa fa-info-circle"></i>
            <p>구매 전 반드시 제공되는 샘플데이터를 확인하시기 바랍니다.</p>
          </div>
        </div>
        <div class="company-info">
          <span>(주)데이터봇</span>
          <span class="divider">|</span>
          <span>대표: 고관후</span>
          <span class="divider">|</span>
          <span>사업자번호: 425-81-02676</span>
          <span class="divider">|</span>
          <span>통신판매업: 2022-서울송파-0915</span>
          <span class="divider">|</span>
          <span>개인정보책임자: 이성영</span>
        </div>
        <div class="copyright">
          <p>© 2024 DATABOT. All rights reserved.</p>
          <div class="footer-terms">
            <a href="#" @click.prevent="$bvModal.show('footer-terms-modal')">이용약관</a>
            <span class="divider">|</span>
            <a href="#" @click.prevent="$bvModal.show('footer-privacy-modal')">개인정보 수집 및 이용</a>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- 이용약관 모달 -->
  <b-modal
    id="footer-terms-modal"
    size="lg"
    centered
    modal-class="modern-modal"
    header-class="modern-modal-header"
    body-class="modern-modal-body"
  >
    <template #modal-header>
      <div class="modal-header-content">
        <h5 class="modal-title-custom">
          <i class="fa fa-file-text"></i>
          디비로봇 이용약관
        </h5>
        <button type="button" class="modal-close-btn" @click="$bvModal.hide('footer-terms-modal')">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </template>
    <pre class="my-4" style="max-height: 400px; white-space: pre-wrap; overflow-y: auto;">
제 1 장 총칙

제 1 조 (목적)
이 약관은 "데이터봇(주)"(이하 "회사")가 운영하는 사이트 "DB ROBOT"(이하 "회사" 또는 "데이터봇(주)"라 한다)이 제공하는 전자상거래 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 이용조건 및 절차, "회사"와 "회원"간의 권리, 의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.

제 2 조 (정의)
이 약관에서 사용되는 용어의 정의는 다음과 같습니다.
1."DB ROBOT"이란 회사가 운영하는 데이터베이스 서비스 플랫폼을 말합니다.
2."회원"이란 본 약관에 동의하고 회원등록을 한 자로서, DB ROBOT의 서비스를 이용하는 자를 말합니다.
3."서비스"란 회사가 제공하는 데이터베이스 정보 제공 및 관련 부가서비스를 의미합니다.
4."판매자"란 DB ROBOT을 통하여 상품을 판매하는 회원을 말합니다.
5."구매자"란 DB ROBOT을 통하여 상품을 구매하는 회원을 말합니다.

제 3 조 (약관의 게시와 개정)
1."데이터봇(주)"은 이 약관의 내용을 회원가입 및 결제화면에 게시합니다.
2.본 약관은 "서비스"에 가입된 "회원"을 포함하여 약관에 동의 후 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다.

제 2 장 서비스 이용계약

제 5 조 (서비스 이용계약 체결 및 승낙, 거부, 유보)
1.이용계약은 "회원"이 서비스이용에 대하여 동의를 하는것으로써 체결됩니다.
2."데이터봇(주)"은 다음 각 호에 해당하는 구매자의 서비스 이용에 대해서는 결제승인을 하지 않거나 사후에 결제승인을 취소할 수 있습니다.

제 9 조 (DB ROBOT 서비스 내용)
1."DB ROBOT"은 "데이터봇(주)"에서 제공하는 안전거래 중계 서비스입니다.
2."DB ROBOT"은 "구매자"에게 직접 상품을 판매하지 않습니다.
3."DB ROBOT"이 제공하는 서비스는 "회원"간 상품의 매매가 이루어질 수 있도록 "DB ROBOT"를 통해 "판매자" "구매자" 간 "전자지급결제대행"서비스를 제공하는 것에 그치며, 어떠한 경우에도 "판매자" 및 "구매자"를 대리하지 않습니다.

제 10 조 (판매자 및 구매자의 의무)
1.판매자의 의무
①상품의 등록은 반드시 판매목적으로, 판매가 가능한 상품만을 등록하여야 하며, 상품의 등록은 "데이터봇(주)"이 정한 양식에 따라 진행하여야 합니다.
②판매자는 상품의 매매와 관련하여 관련법령을 준수하여야 하며, 이 약관 및 "데이터봇(주)"가 서비스 화면에서 고지하는 내용을 준수하여야 합니다.

2. 구매자의 의무
①구매자는 구매의사 없이 판매자의 상품에 구매표시를 하여서는 안 됩니다.
②구매자는 상품을 구매하기 전에 반드시 판매자가 게재한 상품의 내용과 거래의 조건을 확인한 후 구매를 하여야 합니다.

제 17 조 ("데이터봇(주)"의 의무)
1."데이터봇(주)"는 서비스 이용정책 또는 이용약관을 준수합니다.
2."데이터봇(주)"는 관련법률과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.
3."데이터봇(주)"는 "회원"이 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.

제 18 조 ("회원"의 의무)
1."회원"은 다음 행위를 하여서는 안 됩니다.
①신청 또는 변경 시 허위내용의 등록
②타인의 정보도용
③"데이터봇(주)"가 게시한 정보의 변경
④"데이터봇(주)"가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
⑤"데이터봇(주)"와 기타 제3자의 저작권 등 지적재산권에 대한 침해
⑥"데이터봇(주)" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
⑦외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "서비스"에 공개 또는 게시하는 행위
⑧기타 불법적이거나 부당한 행위

제 23 조 (개인정보보호 의무)
"데이터봇(주)"는 "정통망법" 등 관련법률이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법률 및 "데이터봇(주)"의 개인정보취급방침이 적용됩니다.

제 24 조 (책임제한)
1."데이터봇(주)"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.
2."데이터봇(주)"는 "회원"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.
3."데이터봇(주)"는 "회원"이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.

제 25 조 (준거법 및 재판관할)
1."데이터봇(주)"와 "회원" 간 제기된 소송은 대한민국법을 준거법으로 합니다.
2.서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 "데이터봇(주)"의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.

부칙
1.이 약관은 2024년 4월 2일부터 적용됩니다.
    </pre>
    <template #modal-footer>
      <div class="modal-footer-content">
        <button class="modal-confirm-btn" @click="$bvModal.hide('footer-terms-modal')">확인</button>
      </div>
    </template>
  </b-modal>

  <!-- 개인정보처리방침 모달 -->
  <b-modal
    id="footer-privacy-modal"
    size="lg"
    centered
    modal-class="modern-modal"
    header-class="modern-modal-header"
    body-class="modern-modal-body"
  >
    <template #modal-header>
      <div class="modal-header-content">
        <h5 class="modal-title-custom">
          <i class="fa fa-shield"></i>
          개인정보 수집 및 이용
        </h5>
        <button type="button" class="modal-close-btn" @click="$bvModal.hide('footer-privacy-modal')">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </template>
    <pre class="my-4" style="max-height: 300px; white-space: pre-wrap;">
회사는 전자결제대행 및 결제대금예치 서비스, 현금영수증 서비스 그리고 휴대폰 본인확인서비스(이하 "서비스"라 칭함) 신청, 상담, 문의사항 등,
서비스의 제공을 위하여 아래와 같은 개인정보를 수집하고 있습니다.

① 개인정보 수집항목

(1) 필수항목

가. 계약정보
    대표자명, 대표자 휴대폰번호, 전화번호(회사번호는 해당 없음), 이메일주소, 담당자명, 담당자 휴대폰번호,
    담당자 이메일주소, 전화번호(회사번호는 해당 없음)

나. 상기 명시된 개인정보 항목 이외의 "서비스" 이용과정이나 "서비스" 처리 과정에서 다음과 같은 추가 정보들이 자동 혹은 수동으로
    생성되어 수집 될 수 있습니다.
    접속 IP/MAC Address, 쿠키, e-mail, 서비스 접속 일시, 서비스 이용기록, 불량 혹은 비정상 이용기록, 결제기록

다. 기타
    회사는 서비스 이용과 관련한 대금결제, 환불 등에 필요한 다음과 같은 정보 등을 추가로 수집할 수 있습니다.
    계좌번호, 예금주명, 서비스계약일 등

(2) 선택항목

가. 필수항목 이외에 계약서류에 기재된 정보 또는 고객이 제공한 정보
나. 주소, 팩스번호 등

② 수집방법

홈페이지(판매자 회원가입, 문의상담), 서면양식, 팩스, 이메일, 업무제휴 계약을 체결한 제휴사로부터 고객이 제시하는 개인정보 수집
    </pre>
    <template #modal-footer>
      <div class="modal-footer-content">
        <button class="modal-confirm-btn" @click="$bvModal.hide('footer-privacy-modal')">확인</button>
      </div>
    </template>
  </b-modal>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.modern-footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: #fff;
  margin-top: auto;
}

.footer-top {
  padding: 60px 0 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-brand {
  margin-bottom: 30px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.footer-logo {
  height: 45px;
  filter: brightness(2) contrast(2);
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.brand-desc {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 25px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: all 0.3s;
}

.social-link:hover {
  background: #1e90ff;
  transform: translateY(-3px);
  color: #fff;
}

.footer-widget {
  margin-bottom: 30px;
}

.footer-widget h5 {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-widget h5::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 2px;
  background: #1e90ff;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.footer-links a:hover {
  color: #1e90ff;
  transform: translateX(5px);
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.contact-item i {
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #1e90ff;
  font-size: 14px;
}

.contact-item strong {
  display: block;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px;
}

.contact-item p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  margin: 0;
  line-height: 1.5;
}

.footer-bottom {
  background: rgba(0, 0, 0, 0.2);
  padding: 25px 0;
}

.company-info {
  text-align: center;
  margin-bottom: 15px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.company-info .divider {
  margin: 0 15px;
  color: rgba(255, 255, 255, 0.3);
}

.copyright {
  text-align: center;
}

.copyright p {
  margin: 0 0 10px 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.footer-terms {
  font-size: 13px;
}

.footer-terms a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-terms a:hover {
  color: #1e90ff;
}

.footer-terms .divider {
  margin: 0 15px;
  color: rgba(255, 255, 255, 0.3);
}

.footer-disclaimer {
  margin-bottom: 30px;
  padding: 30px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.disclaimer-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 15px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.disclaimer-item:last-child {
  margin-bottom: 0;
}

.disclaimer-item i {
  font-size: 14px;
  color: #fbbf24;
  margin-top: 2px;
  flex-shrink: 0;
  width: 20px;
  text-align: center;
}

.disclaimer-item i.fa-shield {
  color: #60a5fa;
}

.disclaimer-item i.fa-exclamation-triangle {
  color: #fb923c;
}

.disclaimer-item i.fa-balance-scale {
  color: #a78bfa;
}

.disclaimer-item i.fa-ban {
  color: #f87171;
}

.disclaimer-item i.fa-info-circle {
  color: #34d399;
}

.disclaimer-item p {
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  line-height: 1.7;
  margin: 0;
  text-align: left;
}

/* 반응형 */
@media (max-width: 768px) {
  .footer-top {
    padding: 30px 0 20px;
  }

  .footer-top .container {
    padding: 0 20px;
  }

  .footer-top .row {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .footer-top .col-lg-4,
  .footer-top .col-lg-2,
  .footer-top .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0;
  }

  /* 브랜드 섹션 */
  .footer-brand {
    text-align: center;
    padding: 20px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 0;
  }

  .logo-wrapper {
    justify-content: center;
    margin-bottom: 12px;
  }

  .footer-logo {
    height: 35px;
  }

  .logo-text {
    font-size: 20px;
  }

  .brand-desc {
    font-size: 12px;
    margin-bottom: 0;
    line-height: 1.6;
  }

  /* 위젯 섹션 */
  .footer-widget {
    padding: 20px 0 20px 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 0;
  }

  .footer-widget h5 {
    font-size: 14px;
    margin-bottom: 12px;
    text-align: left;
    padding-bottom: 8px;
  }

  .footer-widget h5::after {
    left: 0;
    transform: none;
  }

  .footer-links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 0;
  }

  .footer-links li {
    width: 50%;
    margin-bottom: 0;
    text-align: left;
  }

  .footer-links a {
    font-size: 12px;
    padding: 4px 0;
  }

  .footer-links a:hover {
    transform: none;
  }

  /* 연락처 섹션 */
  .contact-info {
    gap: 12px;
  }

  .contact-item {
    flex-direction: row;
    text-align: left;
    gap: 12px;
    align-items: flex-start;
  }

  .contact-item i {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .contact-item strong {
    font-size: 12px;
    margin-bottom: 3px;
  }

  .contact-item p {
    font-size: 11px;
    line-height: 1.5;
  }

  .contact-item div {
    flex: 1;
  }

  /* Footer Bottom */
  .footer-disclaimer {
    padding: 15px;
    margin-bottom: 15px;
  }

  .disclaimer-item {
    gap: 8px;
    margin-bottom: 10px;
  }

  .disclaimer-item i {
    font-size: 11px;
    width: 14px;
    margin-top: 1px;
  }

  .disclaimer-item p {
    font-size: 10px;
    line-height: 1.5;
  }

  .company-info {
    font-size: 11px;
    line-height: 1.8;
  }

  .company-info span {
    display: inline;
  }

  .company-info .divider {
    margin: 0 6px;
  }

  .copyright p {
    font-size: 12px;
  }

  .footer-terms {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .footer-top {
    padding: 25px 0 15px;
  }

  .footer-top .container {
    padding: 0 15px;
  }

  .footer-brand {
    padding: 15px 0;
  }

  .footer-logo {
    height: 30px;
  }

  .logo-text {
    font-size: 18px;
  }

  .brand-desc {
    font-size: 11px;
  }

  .footer-widget {
    padding: 15px 0 15px 15px;
  }

  .footer-widget h5 {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .footer-links li {
    width: 100%;
  }

  .footer-links a {
    font-size: 11px;
  }

  .contact-item {
    gap: 10px;
  }

  .contact-item i {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .contact-item strong {
    font-size: 11px;
  }

  .contact-item p {
    font-size: 10px;
  }

  .footer-disclaimer {
    padding: 12px;
  }

  .disclaimer-item p {
    font-size: 9px;
  }

  .company-info {
    font-size: 10px;
  }

  .company-info span {
    display: block;
    margin: 3px 0;
  }

  .company-info .divider {
    display: none;
  }

  .copyright p {
    font-size: 11px;
  }

  .footer-terms {
    font-size: 11px;
  }
}

/* Terms and Privacy Modal Styles */
::v-deep .modern-modal .modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

::v-deep .modern-modal-header {
  background: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  border-radius: 12px 12px 0 0;
  padding: 20px 30px;
}

.modal-header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title-custom {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-title-custom i {
  color: #1e90ff;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  transition: color 0.3s;
}

.modal-close-btn:hover {
  color: #2c3e50;
}

::v-deep .modern-modal-body {
  padding: 30px;
}

.modal-footer-content {
  width: 100%;
  text-align: center;
}

.modal-confirm-btn {
  background: #1e90ff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.modal-confirm-btn:hover {
  background: #1876d2;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(30, 144, 255, 0.3);
}

pre {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Scrollbar Styling for Modal */
::v-deep .modern-modal-body pre::-webkit-scrollbar {
  width: 8px;
}

::v-deep .modern-modal-body pre::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::v-deep .modern-modal-body pre::-webkit-scrollbar-thumb {
  background: #1e90ff;
  border-radius: 10px;
}

::v-deep .modern-modal-body pre::-webkit-scrollbar-thumb:hover {
  background: #1876d2;
}
</style>